import React from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import { Formik, Form, Field } from 'formik';
import { Input, Select, YesNo } from "../../formik";
import * as Yup from "yup";
import Alert from "react-s-alert";
import Actions from "../../redux/actions";
import _ from "underscore";

const NewRegister = ({ intl, dispatch }) => {
  const titleOptions = [
    { value: "Mr.", label: "Mr." },
    { value: "Ms.", label: "Ms." },
    { value: "Mrs.", label: "Mrs." },
    { value: "Dr.", label: "Dr." }
  ];
  const userNew = (user) => {
    Alert.warning("user.creating");
    dispatch(Actions.userNew(_.omit(user, "confirmPassword", "terms")))
      .then(resp => {
          Alert.success(intl.formatMessage({ id: resp.message }));
        }
      )
      .catch(err =>
        Alert.error(intl.formatMessage({ id: err.message }))
      );
  }
  return (
    <div className="form-register-right">
      <h3 className="text-primary text-center">{intl.formatMessage({ id: 'new.register' })}</h3>
      <Formik
        onSubmit={(values) => {
          userNew(values);
        }}
        validateOnChange={false}
        validateOnBlur={false}
        initialValues={{
          email: '',
          password: '',
          confirmPassword: '',
          title: '',
          firstName: '',
          lastName: '',
          terms: false,
        }}
        validationSchema={Yup.object().shape({
          email: Yup.string().email(intl.formatMessage({ id: "error.emailinvalid" })).required(),
          firstName: Yup.string().required(),
          lastName: Yup.string().required(),
          password: Yup.string().required().min(6, intl.formatMessage({
            id: "error.atleast6"
          })),
          confirmPassword: Yup.string().when("password", {
            is: val => (val && val.length > 0 ? true : false),
            then: Yup.string().oneOf(
              [Yup.ref("password")],
              intl.formatMessage({
                id: "error.passnomatch"
              })
            )
          }),
          terms: Yup.boolean().oneOf([true], intl.formatMessage({id: 'accept.terms'})),
        })}
        render={({ values, setFieldValue }) => (
          <Form className="">
              <Row>
                <Col sm={3}>
                  <Field
                    defaultselected="Civilité"
                    component={Select}
                    name="title"
                    options={titleOptions}
                  />
                </Col>
                <Col sm={4}>
                  <Field
                    component={Input}
                    type="text"
                    placeholder={`${intl.formatMessage({
                      id: "input.firstname"
                    })}*`}
                    name="firstName"
                  />
                </Col>
                <Col sm={5}>
                  <Field
                    component={Input}
                    type="text"
                    placeholder={`${intl.formatMessage({
                      id: "input.lastname"
                    })}*`}
                    name="lastName"
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <Field
                    type="email"
                    component={Input}
                    placeholder={`${intl.formatMessage({ id: "input.email" })}*`}
                    name="email"
                     />
                </Col>
              </Row>
              <Row>
                <Col sm={6}>
                  <Field
                    component={Input}
                    type="password"
                    placeholder={`${intl.formatMessage({ id: "input.password" })}*`}
                    name="password"
                     />
                </Col>
                <Col sm={6}>
                  <Field
                    component={Input}
                    type="password"
                    placeholder={`${intl.formatMessage({ id: "input.password.confirm" })}*`}
                    name="confirmPassword"
                     />
                </Col>
              </Row>
              <Row>
                <Col xs={12}>
                  <div className="checkbox-custom">
                    <Field
                      component={YesNo}
                      name="terms"
                      id="terms"
                      label={<span>{intl.formatMessage({ id: "input.agreeTerms" })} (<a href={`${process.env.REACT_APP_WP_SITE_ROOT}/privacy-policy/`} rel="noopener noreferrer" target="_blank">{intl.formatMessage({ id: "link.view" })}</a>).<span className="text-primary m-l-30 f-small text-right">*informations obligatoires</span></span>}
                    />
                  </div>
                </Col>
              </Row>
            <div className="text-center">
              <Button
                className="m-t-20"
                type="submit"
                >
                {intl.formatMessage({ id: "button.signup" })}
              </Button>
            </div>
          </Form>
        )}
      />
    </div>
  )
}

export default NewRegister;